export default "__VITE_ASSET__CyaNjvQM__"